/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/~/lodash/_arrayPush.js
 ** module id = 611
 ** module chunks = 0
 **/